import { Component, EventEmitter, OnInit, OnDestroy, Output, TemplateRef, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { EvsUserService } from '../../common/services/EvsUser.service';
import { environment } from 'environments/environment';
import { BsModalService } from 'ngx-bootstrap';
import { SocketService } from '../../common/services/Socket.service';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from '../../common/services/Chat.service';
import { Message } from '../../common/models/message';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ChatComponent } from '../../pages/admin/icontact/chat/chat.component';
import _ from "lodash"
import { UserService } from '../../common/services/User.service';
import { PushNotificationsService } from '../../common/services/Notifycation.service';
import { SocialService } from '../../common/services/Social.service';
import * as socketIo from 'socket.io-client';
import { UtilityService } from 'app/common/services/Utility.service';
import { QueueService } from 'app/common/services/Queue.service';
import { TicketService } from 'app/common/services/Ticket.service';

declare var $: any;
declare const WebPush: any;
declare const DetectRTC: any;


@Component({
  selector: 'admin-header',
  templateUrl: './admin-header.template.html',
  styleUrls: ['admin-header.css'],
  providers: [UserService, BsModalService, SocialService, QueueService]
})

export class AdminHeaderComponent implements OnInit, OnDestroy {
  public no_image = 'assets/images/contact.png';
  data: any;
  detail: any;
  items: any[] = [];
  allCalloutQueues: any[] = [];
  limit: number = 10;
  calloutQueue: any;
  size: number = 10;
  user: any = null;
  typeNav: string = '';
  socket: any = null;
  public phone_out: string = '';
  public modalRef: any = {};

  collapsed: boolean = false;

  code: string = '';
  avaiable_status: any = 'AVAILABLE';
  public channelStatus: any = {
    chatStatus: "AVAILABLE",
    emailStatus: "AVAILABLE",
    facebookStatus: "AVAILABLE",
    zaloStatus: "AVAILABLE"
  }
  public noCalling: any = true;
  public is_show_setting: boolean = false;
  public is_show_detail: boolean = false;
  public isVoiceActivated: boolean = false;
  public image_contact = 'assets/images/contact.png';
  public phone_calling: any = '';
  public phoneLogin: boolean = true;
  public checkRegisterRtc: boolean = false;

  public fb_unread: number = 0;
  public chat_unread: number = 0;
  //socket
  ioConnection: any;
  messages: Message[] = [];
  public tab_top: any = null;
  public sipgatewayUrl: any = null;
  //public sippass: any = "6366868";
  public sippass: any = "azA2023xZBc";
  public is_calling: boolean = false;
  public call_id: any;
  public call_type: any;
  public auto_answer: number = 0;
  public is_zalo_onl: boolean = false;
  public is_facebook_onl: boolean = false;
  public is_mail_onl: boolean = false;
  public is_chat_onl: boolean = false;

  public invite_msg: string = '';
  public msg_obj: any = {};

  @ViewChild('confirm_invite') confirmInvite: ElementRef;
  @ViewChild('confirm_forward') confirmForward: ElementRef;

  //modal chat
  bsModalRef: BsModalRef;


  @Output('newTab') newTab = new EventEmitter();

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private socketService: SocketService,
    private modalService: BsModalService,
    private userService: UserService,
    private queueService: QueueService,
    private chatService: ChatService,
    private ticketService: TicketService,
    private notifycationService: PushNotificationsService,
    private socialService: SocialService
  ) {
    if (localStorage.getItem('User')) {
      this.user = JSON.parse(localStorage.getItem('User'));
    }

    this.handerSocketChat();
    this.getChatUnread();
    this.getAllCalloutQueue();


    this.socketService.missionAnnounced$.subscribe(
      mission => {
        if (mission.action == 'updateNotify') {
          this.chat_unread = (this.chat_unread - mission.data) >= 0 ? this.chat_unread - mission.data : 0;
        }
      })
    this.is_calling = false;
    this.noCalling = true;
    this.notifycationService.requestPermission();
  }
  ngOnDestroy() {
    if (this.socket) {
      console.log("Close socket_id " + this.socket.id);
      this.socket.disconnect();
    }
    this.chatService.closeSocket();
  }
  ngOnInit() {
    let status = localStorage.getItem('status');
    this.avaiable_status = status;
    if (this.socket) {
      this.socket.close();
    }
    let socketUrl = environment.url_socket + localStorage.getItem('Access-Token');
    this.socket = socketIo(socketUrl, { transports: ['websocket'] });

    this.socket.on('connect', function () {
      console.log("Client has connected to the server! socket_id " + this.socket.id);
      this.login();
    }.bind(this));

    this.socket.on('message', function (data) {
      // hàm lắng nghe event trả về từ server
      var msg = data;
      console.log(JSON.stringify(data));
      switch (msg.objectId) {
        case environment.code.LOGOUT_RESPOND_ID: {
          this.logoutOthers();
          break;
        }
        case environment.code.VOICE_ACTIVATED: {
          this.afterLogin(msg.data);
          break;
        }
        case environment.code.LOGIN_RESPOND_ID: {
          localStorage.setItem('username', msg.data.username);
          localStorage.setItem('agentId', msg.data.agentId);
          if (msg.data.status == 'OK') {
            this.socketService.setSocket(this.socket);
            this.avaiable_status = msg.data.userStatus;
            this.auto_answer = msg.data.autoAnswer;
          }
          else {
            //this.changeAvaiable('NOT AVAILABLE');
            console.log("login error code " + msg.data.status);
            this.logout();
          }
          break;
        }
        case environment.code.USER_PHONE_SELECT: {
          this.auto_answer = msg.data.autoAnswer;
          if (this.isVoiceActivated) {
            if (msg.data.status == 'OK') {
              this.toastr.success('Cấu hình Phone voice thành công', '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
              });
              this.phoneLogin = msg.data.phoneType == 0 ? true : false;
              if (this.phoneLogin) {
                this.unRegisterRTC();
                this.registerRTC();
                this.checkBrowser();
              } else {
                if (this.checkRegisterRtc) {
                  this.unRegisterRTC();
                }
              }
            } else {
              this.toastr.error('Cấu hình Phone voice thất bại', '', {
                timeOut: 1000,
                positionClass: 'toast-bottom-right'
              });
            }
          }
          break;
        }
        case environment.code.CHANGE_AGENT_STATUS_RESPOND_ID: {
          if (msg.data.errorcode == 0) {
            if (this.user.agent_id == msg.data.agentId) {
              this.avaiable_status = msg.data.status;
              this.channelStatus = {
                chatStatus: msg.data.chatStatus,
                emailStatus: msg.data.emailStatus,
                facebookStatus: msg.data.facebookStatus,
                zaloStatus: msg.data.zaloStatus
              }
              this.responseChangeAvaiable(this.avaiable_status);
            }
            this.socketService.execMsg(this.user.email, msg.objectId, msg.data, this.isVoiceActivated);
          } else {
            this.avaiable_status = this.user.avaiable_status;
            this.toastr.error('Thay đổi trạng thái thất bại', '', {
              timeOut: 1000,
              positionClass: 'toast-bottom-right'
            });
          }
          break;
        }
        default: {
          this.listen(msg);
          this.socketService.execMsg(this.user.email, msg.objectId, msg.data, this.isVoiceActivated);
          break;
        }
      }
    }.bind(this))

    this.socket.on('disconnect', function () {
      console.log("The client has disconnected!");
    });
    // if (this.socket) {
    //   this.socket.close();
    // }
    // this.socket = new WebPush();
    // this.socket.connect(environment.url_socket, false);

    // this.socket.webSocket.onerror = function () {
    //   this.toastr.error("Không thể kết nối đến server, xin vui lòng thử lại Refresh(F5) để kết nối lại", 'Mất kết nối', {
    //     positionClass: 'toast-bottom-right',
    //     closeButton: true,
    //     enableHtml: true,
    //     tapToDismiss: false,
    //     timeOut: 0
    //   });
    // }.bind(this);

    // this.socket.webSocket.onclose = function () {
    //   this.toastr.error("Không thể kết nối đến server, xin vui lòng thử lại Refresh(F5) để kết nối lại", 'Mất kết nối', {
    //     positionClass: 'toast-bottom-right',
    //     closeButton: true,
    //     enableHtml: true,
    //     tapToDismiss: false,
    //     timeOut: 0
    //   });
    // }.bind(this);

    // this.socket.webSocket.onmessage = function (evt) {
    //   var msg = JSON.parse(evt.data);
    //   console.log('messagee trả  về ', msg);
    //   switch (msg.objectId) {
    //     case environment.code.LOGIN_RESPOND_ID: {
    //       if (msg.data.status == 'OK') {
    //         localStorage.setItem('username', msg.data.username);
    //         localStorage.setItem('agentId', msg.data.agentId);
    //         this.socketService.setSocket(this.socket);
    //         this.afterLogin(msg.data);
    //         this.avaiable_status = msg.data.agentStatus
    //       }
    //       else {
    //         this.changeAvaiable('NOT AVAILABLE');
    //       }
    //       break;
    //     }
    //     case environment.code.USER_PHONE_SELECT: {
    //       if (msg.data.status == 'OK') {
    //         this.toastr.success('Cấu hình Phone voice thành công', '', {
    //           timeOut: 1000,
    //           positionClass: 'toast-bottom-right'
    //         });
    //         this.phoneLogin = msg.data.phoneType == 0 ? true : false;
    //         if (this.phoneLogin) {
    //           // this.unRegisterRTC();
    //           // this.registerRTC();
    //           this.checkBrowser();
    //         }
    //       } else {
    //         this.toastr.error('Cấu hình Phone voice thất bại', '', {
    //           timeOut: 1000,
    //           positionClass: 'toast-bottom-right'
    //         });
    //       }
    //       break;
    //     }
    //     case environment.code.CHANGE_AGENT_STATUS_RESPOND_ID: {
    //       if (msg.data.status == 'OK') {
    //         this.responseChangeAvaiable(this.avaiable_status);
    //       } else {
    //         this.avaiable_status = this.user.avaiable_status;
    //         this.toastr.error('Thay đổi trạng thái thất bại', '', {
    //           timeOut: 1000,
    //           positionClass: 'toast-bottom-right'
    //         });
    //       }
    //       break;
    //     }
    //     default: {
    //       this.listen(msg);
    //       this.socketService.execMsg(this.user.email, msg.objectId, msg.data);
    //       break;
    //     }
    //   }

    // }.bind(this)
  }

  sendDisconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  sendMessage(event) {
    // hàm gửi event cho server
    var appMessage = { objectId: event.objectId, data: event };
    this.socket.emit('message', appMessage);
  }

  // ngAfterViewInit() {
  //   setTimeout(function () {
  //     this.login();
  //   }.bind(this), 3000);
  // }

  getAllCalloutQueue() {
    this.queueService.listCalloutQueues().subscribe(rs => {
      console.log(rs)
      if (rs.status == 200 && !rs.error) {
        this.allCalloutQueues = rs.data.queues;
        let queue = localStorage.getItem("calloutDefault");
        if (!queue) {
          if (this.allCalloutQueues.length > 0) {
            queue = this.allCalloutQueues[0].QUEUE_ID;
          } else {
            queue = "";
          }
          localStorage.setItem("calloutDefault", queue);
        }
        this.calloutQueue = queue;
      }
    })
  }


  handerSocketChat() {
    this.chatService.initSocket(this.user.tenant_id, this.user._id, this.user.role, this.user.name, this.user._id);
    this.chatService.onUpdateChatting().subscribe((message: any) => {
      // if (message.agent_id == this.user.id) {
      //   this.chat_unread = this.chat_unread + 1;
      //   this.handleTitle(this.chat_unread);
      //   this.userService.find({ _id: message.chatter_id }).subscribe(rs => {
      //     if (rs.status == 200 && !rs.error) {
      //       this.notifycationService.generateNotification([{
      //         title: message.chatter_name,
      //         content: message.content,
      //         icon: rs.data.avatar ? rs.data.avatar : this.no_image
      //       }])
      //     }
      //   })

      // }
    })

    this.chatService.onInviteChat().subscribe((message: any) => {
      this.msg_obj = message;
      if (message.agent_id == this.user._id) {
        if (message.status == 'invite') {
          this.invite_msg = message.from_user + " mời bạn tham gia chat với khách hàng";
          let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
          }
          this.modalRef = this.modalService.show(this.confirmInvite, config);
        }

      }
    })

    this.chatService.onForwardChat().subscribe((message: any) => {
      this.msg_obj = message;
      if (message.agent_id == this.user._id) {
        if (message.status == 'forward') {
          this.invite_msg = message.from_user + " chuyển cuộc hội thoại tới bạn hỗ trợ";
          let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
          }
          this.modalRef = this.modalService.show(this.confirmForward, config);
        }
      }
    })

    this.chatService.onUpdateChattingInternal().subscribe((message: any) => {
      let check = _.find(message.agents, { agent_id: this.user.id });
      if (check) {
        this.chat_unread = this.chat_unread + 1;

        this.userService.find({ _id: message.chatter_id }).subscribe(rs => {
          if (rs.status == 200 && !rs.error) {
            this.notifycationService.generateNotification([{
              title: message.chatter_name,
              content: message.content,
              icon: rs.data.avatar ? rs.data.avatar : this.no_image
            }])
          }
        })
      }
    })
  }

  rejectInviteChat() {
    this.chatService.inviteChat(this.msg_obj.from_user_id, this.user._id, this.user.name,
      this.user.tenant_id, this.msg_obj.ticket_id, 'reject');
    this.modalRef.hide();
  }

  rejectForwardChat() {
    let payload = {
      agent_id: this.msg_obj.from_user_id,
      from_user_id: this.user._id,
      from_user: this.user.name,
      tenant_id: this.user.tenant_id,
      ticket_id: this.msg_obj.ticket_id,
      status: 'reject'
    }
    this.chatService.forwardChat(payload);
    this.modalRef.hide();
  }

  acceptInviteChat() {
    this.modalRef.hide();
    this.ticketService.updateMany({ _id: this.msg_obj.ticket_id }, { $addToSet: { in_room: this.user._id } }).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.chatService.join(this.msg_obj.ticket_id);
        this.socketService.updateChatData({});
        // this.loadData();
        this.chatService.inviteChat(this.msg_obj.from_user_id, this.user._id, this.user.name,
          this.user.tenant_id, this.msg_obj.ticket_id, 'accept');

        this.chatService.send(this.msg_obj.ticket_id, {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: '',
          type: 'action-join', //image , file
          avatar: '',
          date: Date.now()
        })
      }
    })
  }

  acceptForwardChat() {
    let payload = {
      agent_id: this.msg_obj.from_user_id,
      from_user_id: this.user._id,
      from_user: this.user.name,
      tenant_id: this.user.tenant_id,
      ticket_id: this.msg_obj.ticket_id,
      status: 'accept'
    }
    this.modalRef.hide();
    this.ticketService.updateMany({ _id: this.msg_obj.ticket_id }, {
      $set: { receiver_id: this.user._id },
      $pull: { in_room: this.msg_obj.from_user_id }
    }).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.chatService.join(this.msg_obj.ticket_id);
        this.chatService.forwardChat(payload); //send socket
        // this.loadData();
        this.socketService.updateChatData({});
        this.chatService.send(this.msg_obj.ticket_id, {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: '',
          type: 'action-join', //image , file
          avatar: '',
          date: Date.now()
        })
      }
    })
    this.ticketService.updateMany({ _id: this.msg_obj.ticket_id }, { $addToSet: { in_room: this.user._id } }).subscribe(res => {
    })
  }

  redirectTo(url) {
    this.router.navigate([url]);
  }

  getChatUnread() {
    this.chatService.unread().subscribe(res => {
      this.chat_unread = res.data[0] ? res.data[0].total : 0;
      this.handleTitle(this.chat_unread);
    })
  }

  private checkBrowser() {
    var constraints = { audio: true };
    navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        this.toastr.success('Kết nối tới thiết bị nghe gọi của bạn thành công', '', {
          timeOut: 1000,
          positionClass: 'toast-bottom-right'
        });
      })
      .catch(e => {
        if (DetectRTC.isWebRTCSupported === false) {
          this.toastr.info('Trình duyệt của bạn không hỗ trợ thiết bị liên bị nghe gọi, xin vui lòng thử trình duyệt khác', '', {
            timeOut: 1000,
            positionClass: 'toast-bottom-right'
          });
        }


        if (DetectRTC.hasMicrophone === false) {
          this.toastr.info('Không thể kết nối tới thiết bị nghe gọi của bạn.Hãy kiểm tra lại tai nghe và micro của bạn', '', {
            timeOut: 1000,
            positionClass: 'toast-bottom-right'
          });
        }

        if (DetectRTC.hasSpeakers === false && (DetectRTC.browser.name === 'Chrome' || DetectRTC.browser.name === 'Edge')) {
          this.toastr.info('Micro của bạn gặp vấn đề. Xin vui lòng kiểm tra lại micro của bạn', '', {
            timeOut: 1000,
            positionClass: 'toast-bottom-right'
          });
        }
      });
  }

  unRegisterRTC() {
    this.checkRegisterRtc = false;
    (window as any).unregister();
    // this.chatService.monitor({
    //   event: 'agent_offline_phone',
    //   id: this.user._id,
    //   tenant_id: this.user.tenant_id
    // })
  }

  registerRTC() {
    if (this.sipgatewayUrl) {
      (window as any).init_ua(this.user.agent_id, this.sippass, this.sipgatewayUrl, 'wss://' + this.sipgatewayUrl);
    }
    let state = (window as any).state;
    if ((window as any).ua) {
      (window as any).ua.on('newRTCSession', function (e) {
        this.is_show_detail = true;
        this.noCalling = false;
        let session = e.session;
        session.on('ended', function (e) {
          this.noCalling = true;
          this.is_calling = false;
          this.call_type = "";
        }.bind(this));

        session.on('failed', function (e) {
          this.noCalling = true;
          this.is_calling = false;
          this.call_type = "";
        }.bind(this));
      }.bind(this));

      (window as any).ua.on('registered', function (e) {
        this.checkRegisterRtc = true;
        // this.chatService.monitor({
        //   event: 'agent_online_phone',
        //   id: this.user._id,
        //   tenant_id: this.user.tenant_id
        // })
      }.bind(this));

    }

    if (state.status == 'unregistered' || state.status == 'disconnected') {
      this.checkRegisterRtc = false;
      // this.chatService.monitor({
      //   event: 'agent_offline_phone',
      //   id: this.user._id,
      //   tenant_id: this.user.tenant_id
      // })
    } else {
      this.checkRegisterRtc = true;
      // this.chatService.monitor({
      //   event: 'agent_online_phone',
      //   id: this.user._id,
      //   tenant_id: this.user.tenant_id
      // })
    }
  }

  private afterLogin(data) {
    this.phoneLogin = data.phoneType == 0 ? true : false;
    this.sipgatewayUrl = data.sipGatewayUrl;
    if (data.sippass !== undefined) {
      this.sippass = data.sippass;
    }
    this.isVoiceActivated = data.isVoiceActivated;
    if (data.isVoiceActivated) {
      if (this.phoneLogin) {
        if (this.checkRegisterRtc) {
          this.unRegisterRTC();
        }
        this.registerRTC();
        this.checkBrowser();
      }
    } else {
      if (this.checkRegisterRtc) {
        this.unRegisterRTC();
      }
    }
  }

  activateVoice() {
    this.socketService.activateVoice();
  }

  webRtcAnswer() {
    (window as any).answer_call();
    this.is_show_detail = false;
    this.is_calling = true;
  }

  webRtcReject() {
    if (this.call_id) {
      this.socketService.execEndCall({ callId: this.call_id })
    }
    this.noCalling = true;
    this.is_show_detail = false;
    this.is_calling = false;
  }
  /**
   * Thực hiện Outcall 
   */
  execCall() {
    if (this.phone_out) {
      this.phone_out = this.phone_out.replace(new RegExp(' ', 'g'), '')
      if (UtilityService.isValidPhoneNumber(this.phone_out)) {
        this.socketService.execCall(this.phone_out);
      } else {
        this.toastr.error('', 'Số điện thoại không hợp lệ', {
          timeOut: 1000,
          positionClass: 'toast-bottom-right'
        });
      }

    }
  }

  onBackspace() {
    this.phone_out = this.phone_out.substring(0, this.phone_out.length - 1);
  }

  onclick(number) {
    this.phone_out += number;
  }

  clear_phone_out() {
    this.phone_out = '';
  }

  showMore(): void {
    window.open('notify_manager');
  }

  toggle_sidebar() {
    this.collapsed = !this.collapsed;
  }

  voice(type) {
    this.checkRegisterRtc = false;
    // 0: webrtc, 1: sipphone can dang nhap, 2: sipphone khong can dang nhap, 3: so di dong
    this.socketService.voiceSetting({
      phoneType: type
    })
  }

  changeAutoAnswer() {
    this.socketService.voiceSetting({
      autoAnswer: this.auto_answer == 0 ? 1 : 0
    })
  }

  changeCalloutQueue() {
    localStorage.setItem('calloutDefault', this.calloutQueue);
  }

  goHome() {
    location.href = '/';
  }

  openModal(template: TemplateRef<any>) {
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false
    }
    this.modalRef = this.modalService.show(template, config);

  }

  listen(msg) {
    switch (msg.objectId) {
      case environment.code.NEW_EMAIL_RESPOND_ID: {
        this.handleTitle(1);
        this.toastr.info(msg.emailSubject ? msg.emailSubject : msg.title//'Thư mới từ ' + msg.emailFrom
          , msg.emailFrom, {
          timeOut: 1000,
          positionClass: 'toast-bottom-right'
        });
        break;
      }
      case environment.code.OUT_CALL_RESPONSE_ID: {
        this.phone_calling = msg.data.caller;
        this.call_id = msg.data.callId;
        this.call_type = "CALL_OUTBOUND";
        if (msg.data.errorCode == "OK") {
          if (this.isVoiceActivated) {
            if (this.auto_answer == 1 && this.checkRegisterRtc) {
              this.webRtcAnswer();
            }
          }
        }
        break;
      }
      case environment.code.RING_AGENT_RESPOND_ID: {
        //this.is_show_detail = true;
        this.noCalling = false;
        this.handleTitle(1);
        this.phone_calling = msg.data.caller;
        this.call_type = msg.data.callType;
        this.call_id = msg.data.callId;
        if (this.isVoiceActivated) {
          if (msg.data.campaignId && msg.data.campaignId != "HAPPYCALL") {
            if (this.auto_answer == 1 && this.checkRegisterRtc) {
              this.webRtcAnswer();
            }
          }
          else if (this.auto_answer == 1 && this.checkRegisterRtc &&  this.call_type == 'CALL_INBOUND') {
            this.webRtcAnswer();
          }
        }
        break;
      }

      case environment.code.AGENT_ANSWER_RESPOND_ID: {
        this.handleTitle(-1);
        this.is_show_detail = false;
        this.is_show_setting = false;
        this.call_id = msg.data.callId;
        this.noCalling = false;
        break;
      }
      case environment.code.AGENT_END_CALL_RESPOND_ID: {
        this.is_show_detail = false;
        this.is_show_setting = false;
        this.noCalling = true;
        this.call_id = null;
        this.is_calling = false;
        break;
      }
      case environment.code.END_CALL_RESPOND_ID: {
        this.is_show_detail = false;
        this.is_show_setting = false;
        this.noCalling = true;
        this.call_id = null;
        this.is_calling = false;
        break;
      }
      default: break;
    }

  }

  changeAvaiable(status) {
    this.avaiable_status = status.toString();
    this.socketService.changeAgentStatus({ status: status });
  }

  changeChannelStatus(channel) {
    let status = this.channelStatus[channel] == "AVAILABLE" ? "NOT AVAILABLE" : "AVAILABLE";
    this.channelStatus[channel] = status;
    let data = {};
    data[channel] = status;
    this.socketService.changeAgentStatus(data);
  }

  responseChangeAvaiable(status) {
    this.userService.update(this.user._id, { avaiable_status: status }).subscribe(rs => {
      if (rs.status == 200) {
        localStorage.setItem('User', JSON.stringify(rs.data));
        localStorage.setItem('status', status.toString());
        this.avaiable_status = status.toString();
      }
    })
  }


  login() {
    if (!this.socket || !this.user.agent_id) {
      this.toastr.error('', 'Mất kết nối đến server. Vui lòng thử lại sau', {
        timeOut: 1000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }
    this.socket.send({
      objectId: environment.code.LOGIN_REQUEST_ID,
      data: {
        objectId: environment.code.LOGIN_REQUEST_ID,
        avatar: this.user.avatar,
        username: this.user.email,
        name: this.user.name,
        agentId: this.user.agent_id,
        userType: this.user.role,
        token: localStorage.getItem('Access-Token'),
        tenantId: this.user.tenant_id || this.user._id,
        groupId: this.user.group_id,
        shiftId: 1
      }
    })
  }


  profile() {
    this.socketService.opentab(this.user, 'user', 'edit');
  }
  showBoxVoiceSetting() {
    this.is_show_setting = this.is_show_setting ? false : true;
  }
  showBoxDetail() {
    this.is_show_detail = this.is_show_detail ? false : true;
    this.is_show_setting = false;
  }

  showBoxChat() {
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false
    }
    this.bsModalRef = this.modalService.show(ChatComponent, config);
  }

  handleTitle(number) {
    // let number_text = $('#alert-title').text().trim();
    // number_text = number_text.replace('(','');
    // number_text = number_text.replace(')','');
    // let number_cur = parseInt(number_text) ? parseInt(number_text):0;
    // number_cur += number;
    // if(number_cur > 0) {
    //   $('#alert-title').text('('+number_cur+') I-Contact');
    // }
  }
  logout() {
    console.log("Try to logout!!!");
    this.unRegisterRTC();
    try {
      this.socketService.logout();
    } catch (e) {
      console.log('error logout', e);
    }
    console.log("Logged out!!!");
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  logoutOthers() {
    this.unRegisterRTC();
    console.log("Try to logout others!!!")
    console.log("Logged out others!!!");
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}





// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/header/admin-header.component.ts